/** Maximum number of quarters to show in quarterly line/bar charts. */
export const MAX_QUARTERS_CHART = 8;

/** Matches subawardee dashboard goal reference lines (`#fa5252`). */
export const CHART_GOAL_LINE_COLOR = '#fa5252';

export const CHART_GOAL_LINE_PROPS = {
  stroke: CHART_GOAL_LINE_COLOR,
  strokeWidth: 2,
  strokeDasharray: '4 4',
} as const;
